var _circle, _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#0A4FB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5681 14.3302L35.2473 24.163M43.5869 21.4518C43.5862 20.7822 43.4147 20.1245 43.0894 19.5447C42.7641 18.965 42.2966 18.4836 41.7337 18.1487L28.761 10.5116C28.1975 10.1764 27.5583 10 26.9077 10C26.2571 10 25.6179 10.1764 25.0545 10.5116L12.0818 18.1487C11.5189 18.4836 11.0513 18.965 10.726 19.5447C10.4008 20.1245 10.2292 20.7822 10.2285 21.4518V36.7261C10.2292 37.3957 10.4008 38.0534 10.726 38.6332C11.0513 39.2129 11.5189 39.6943 12.0818 40.0292L25.0545 47.6663C25.6179 48.0015 26.2571 48.1779 26.9077 48.1779C27.5583 48.1779 28.1975 48.0015 28.761 47.6663L41.7337 40.0292C42.2966 39.6943 42.7641 39.2129 43.0894 38.6332C43.4147 38.0534 43.5862 37.3957 43.5869 36.7261V21.4518Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7832 19.542L26.9064 29.0884M26.9064 29.0884L43.0297 19.542M26.9064 29.0884V48.1813",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.9922,
    y: 29.0908,
    width: 22.2367,
    height: 22.9091,
    rx: 11.1183,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9484 36.0032H38.5176V34.5894H41.9484C42.8583 34.5894 43.7309 34.9617 44.3743 35.6246C45.0177 36.2875 45.3792 37.1865 45.3792 38.1239V38.8308C45.3792 39.7682 45.0177 40.6673 44.3743 41.3301C43.7309 41.993 42.8583 42.3654 41.9484 42.3654H38.5176V40.9515H41.9484C42.4943 40.9515 43.0179 40.7281 43.4039 40.3304C43.79 39.9327 44.0069 39.3933 44.0069 38.8308V38.1239C44.0069 37.5614 43.79 37.022 43.4039 36.6243C43.0179 36.2266 42.4943 36.0032 41.9484 36.0032Z",
    fill: "#0A4FB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5182 34.5894C38.7002 34.5894 38.8747 34.6638 39.0034 34.7964C39.1321 34.929 39.2044 35.1088 39.2044 35.2963V46.2534C39.2044 46.4408 39.1321 46.6206 39.0034 46.7532C38.8747 46.8858 38.7002 46.9603 38.5182 46.9603C38.3362 46.9603 38.1617 46.8858 38.033 46.7532C37.9043 46.6206 37.832 46.4408 37.832 46.2534V35.2963C37.832 35.1088 37.9043 34.929 38.033 34.7964C38.1617 34.6638 38.3362 34.5894 38.5182 34.5894Z",
    fill: "#0A4FB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7734 37.3719C35.7734 37.1845 35.8457 37.0047 35.9744 36.8721C36.1031 36.7395 36.2776 36.665 36.4596 36.665H46.0658C46.2478 36.665 46.4223 36.7395 46.551 36.8721C46.6797 37.0047 46.752 37.1845 46.752 37.3719C46.752 37.5594 46.6797 37.7392 46.551 37.8718C46.4223 38.0044 46.2478 38.0789 46.0658 38.0789H36.4596C36.2776 38.0789 36.1031 38.0044 35.9744 37.8718C35.8457 37.7392 35.7734 37.5594 35.7734 37.3719ZM35.7734 39.4927C35.7734 39.3052 35.8457 39.1254 35.9744 38.9928C36.1031 38.8602 36.2776 38.7858 36.4596 38.7858H46.0658C46.2478 38.7858 46.4223 38.8602 46.551 38.9928C46.6797 39.1254 46.752 39.3052 46.752 39.4927C46.752 39.6802 46.6797 39.86 46.551 39.9925C46.4223 40.1251 46.2478 40.1996 46.0658 40.1996H36.4596C36.2776 40.1996 36.1031 40.1251 35.9744 39.9925C35.8457 39.86 35.7734 39.6802 35.7734 39.4927Z",
    fill: "#0A4FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryValue);
export default __webpack_public_path__ + "static/media/inventory_Value.a611ea800fdf11c15e9c7f7d0520f5da.svg";
export { ForwardRef as ReactComponent };